<template>
  <div
    class="pic-carcousel"
    ref="picCarcousel"
  >
    <el-carousel
      trigger="click"
      style="height: 100%"
      :interval="interval"
      v-show="!noData"
    >
      <el-carousel-item
        v-for="item in pictureList"
        :key="item.id"
      >
        <img
          ref="img"
          :src="item.img"
          :style="{'height':`${height}px`,'width':`${width}px`,'margin-top':`${marginTop}px`,'margin-left':`${marginLeft}px`}"
        />
      </el-carousel-item>
    </el-carousel>
    <no-data v-show="noData"></no-data>
  </div>
</template>

<script>
/*
   * 图片轮播小部件
   * 传入参数
   * widgetId 图片请求地址id
   * interval 轮播时间
   * */
import api from 'api/api'
import noData from './no-data'
export default {
  name: 'pic-carcousel',
  props: {
    widgetId: {
      // 轮播录图片请求id
      type: String,
      default: ''
    },
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noData: false,
      interval: 3000, // 轮播时间 当时间为0时，不轮播
      height: '',
      width: '',
      marginTop: '',
      marginLeft: '',
      pictureList: [] // 图片轮播数组
    }
  },
  components: {
    noData
  },
  mounted () {
    this.init()
    this.loopRefreshWidget()
    window.addEventListener('resize', this.resizeImage)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeImage)
  },
  methods: {
    // 轮巡请求
    loopRefreshWidget () {
      if (this.refreshPeriod !== 0) {
        setInterval(() => {
          this._getData()
        }, this.refreshPeriod * 1000)
      }
    },
    init () {
      this._getData()
    },
    // 获取数据
    _getData () {
      api.widget
        .getData(this.widgetId)
        .then(data => {
          this.pictureList = data.data.list || []
          this.interval = data.data.interval
          if (this.pictureList.length !== 0) {
            this.noData = false
            this.load()
          } else {
            this.noData = true
          }
        })
        .catch(() => {
          this.noData = true
        })
    },
    // 加载图片并做垂直居中处理
    load () {
      let _this = {
        height: this.$refs.picCarcousel.offsetHeight,
        width: this.$refs.picCarcousel.offsetWidth
      }
      let _image = new Image()
      _image.onload = () => {
        if (_image.width > 0 && _image.height > 0) {
          if (_image.width / _image.height >= _this.width / _this.height) {
            if (_image.width > _this.width) {
              this.width = _this.width
              this.height = _image.height * _this.width / _image.width
            } else {
              this.width = _image.width
              this.height = _image.height
            }
          } else {
            if (_image.height > _this.height) {
              this.height = _this.height
              this.width = _image.width * _this.height / _image.height
            } else {
              this.width = _image.width
              this.height = _image.height
            }
          }
          if (this.height < _this.height) {
            this.marginTop = (_this.height - this.height) / 2
          } else {
            this.marginTop = 0
          }
          if (this.width < _this.width) {
            this.marginLeft = (_this.width - this.width) / 2
          } else {
            this.marginLeft = 0
          }
        }
      }
      _image.src = this.pictureList[0].img
    },
    resizeImage () {
      if (this.pictureList.length !== 0) {
        this.load()
      }
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.pic-carcousel {
  width: 100%;
  height: 100%;
}
</style>
